import { render, staticRenderFns } from "./organization-risk-dashboard.vue?vue&type=template&id=fb9c7268&scoped=true&"
import script from "./organization-risk-dashboard.vue?vue&type=script&lang=js&"
export * from "./organization-risk-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./organization-risk-dashboard.vue?vue&type=style&index=0&id=fb9c7268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9c7268",
  null
  
)

export default component.exports